import { Uuid, uuidSerializer } from "@legacy-megarax/common";
import { MSerializers } from "@legacy-megarax/serializers";

export interface CreateVisitChecklistInput {
  visitUuid: Uuid;
  customerUuid: Uuid;
}

export interface ToggleTaskInput {
  taskUuid: Uuid;
}

export const toggleTaskInputSerializer = MSerializers.object<ToggleTaskInput>({
  taskUuid: uuidSerializer,
});
